var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRequestDenied = function SvgRequestDenied(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CF706C",
    fillRule: "nonzero",
    stroke: "#CF706C",
    strokeWidth: 0.5,
    d: "M2.387 8.044l2.116-2.116 2.113 2.113a1 1 0 0 0 1.414 0l.011-.011a1 1 0 0 0 0-1.414L5.928 4.503l2.116-2.116a1 1 0 0 0 0-1.414L8.027.956a1 1 0 0 0-1.414 0L4.497 3.072 2.384.959a1 1 0 0 0-1.414 0L.96.97a1 1 0 0 0 0 1.414l2.113 2.113L.956 6.613a1 1 0 0 0 0 1.414l.017.017a1 1 0 0 0 1.414 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRequestDenied);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/request-denied.200dd5844f8259e04343a96f33f01a5f.svg";